"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** The list of personality types. */
exports.default = Object.freeze([
    'authority',
    'economically',
    'humanely',
]);
//# sourceMappingURL=vector.js.map